import React from 'react';
import { Phone, FileText, AlertTriangle, CheckCircle, Ruler, Scale, Clock, Car } from 'lucide-react';
export function OverSizedLoadPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-3111">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-3112">
        <div className="container mx-auto px-4" data-id="element-3113">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-3114">
            Oversize or Overweight Vehicles and Loads
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-3115">
            Special Permit Requirements & Procedures
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-3116">
        <div className="max-w-4xl mx-auto" data-id="element-3117">
          {/* General Procedure */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3118">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center" data-id="element-3119">
              <FileText className="mr-3 text-[#B1050B]" size={28} data-id="element-3120" />
              General Procedure
            </h2>

            <div className="space-y-6" data-id="element-3121">
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6" data-id="element-3122">
                <p className="text-gray-700" data-id="element-3123">
                  The statutes of the State of Michigan authorize the Department
                  of Transportation to issue special permits for the movement
                  over state highways of vehicles or loads which exceed the size
                  or weight limitations specified by law.
                </p>
              </div>

              <div className="bg-green-50 rounded-lg p-6" data-id="element-3124">
                <h3 className="font-bold text-gray-900 mb-4" data-id="element-3125">
                  Purpose of the Department:
                </h3>
                <p className="text-gray-700 mb-4" data-id="element-3126">
                  To permit the movement of necessary overweight and oversize
                  vehicles or loads consistent with the following obligations:
                </p>

                <div className="space-y-3" data-id="element-3127">
                  <div className="bg-white rounded-lg p-4 flex items-start" data-id="element-3128">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3129">
                      A
                    </span>
                    <div data-id="element-3130">
                      <p className="font-bold text-gray-900 mb-1" data-id="element-3131">
                        Protection of the Motoring Public
                      </p>
                      <p className="text-gray-700" data-id="element-3132">
                        From potential traffic hazards
                      </p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 flex items-start" data-id="element-3133">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3134">
                      B
                    </span>
                    <div data-id="element-3135">
                      <p className="font-bold text-gray-900 mb-1" data-id="element-3136">
                        Protection of Infrastructure
                      </p>
                      <p className="text-gray-700" data-id="element-3137">
                        Highway surfaces, structures, and private property
                      </p>
                    </div>
                  </div>

                  <div className="bg-white rounded-lg p-4 flex items-start" data-id="element-3138">
                    <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3139">
                      C
                    </span>
                    <div data-id="element-3140">
                      <p className="font-bold text-gray-900 mb-1" data-id="element-3141">
                        Normal Traffic Flow
                      </p>
                      <p className="text-gray-700" data-id="element-3142">
                        Provisions for normal flow with minimum interference
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Conditions and Limitations */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-3143">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-3144">
              Conditions and Limitations
            </h2>

            <div className="space-y-6" data-id="element-3145">
              {/* Section A */}
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-3146">
                <div className="flex items-start mb-3" data-id="element-3147">
                  <span className="bg-blue-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3148">
                    A
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3149">
                    Permit Eligibility
                  </h3>
                </div>
                <p className="text-gray-700 ml-14" data-id="element-3150">
                  Permits are issued only to business entities or individuals
                  actually doing the transporting. The transporting vehicles to
                  be used must be owned by the applicant or operated under a
                  bona fide lease or rental agreement.
                </p>
              </div>

              {/* Section B */}
              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-3151">
                <div className="flex items-start mb-3" data-id="element-3152">
                  <span className="bg-yellow-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3153">
                    B
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3154">
                    Load Requirements
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3155">
                  <p data-id="element-3156">
                    The issuance of permits is limited to those vehicles and/or
                    loads which{' '}
                    <strong data-id="element-3157">
                      cannot reasonably be divided, dismantled, reduced, or
                      otherwise rearranged
                    </strong>{' '}
                    to conform to legal dimensions and/or weights as provided by
                    law.
                  </p>

                  <div className="bg-white rounded-lg p-4" data-id="element-3158">
                    <p className="font-semibold mb-2" data-id="element-3159">Load Arrangement:</p>
                    <ul className="space-y-1 text-sm" data-id="element-3160">
                      <li data-id="element-3161">
                        • Loads shall be arranged to effect the minimum
                        dimensions for height, length, or width
                      </li>
                      <li data-id="element-3162">
                        • <strong data-id="element-3163">Staggered loading is not permitted</strong>
                      </li>
                      <li data-id="element-3164">
                        • If a loaded commodity creates a single over-dimension,
                        two or more commodities may be transported as one load
                        provided:
                        <ul className="ml-4 mt-1" data-id="element-3165">
                          <li data-id="element-3166">- Permit application indicates this</li>
                          <li data-id="element-3167">- Legal axle loadings are not exceeded</li>
                          <li data-id="element-3168">
                            - No additional nonconforming dimensions are created
                            or made greater
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-l-4 border-red-500 p-4" data-id="element-3169">
                    <p className="font-semibold text-red-900 mb-2" data-id="element-3170">
                      Double Bottoms Restriction:
                    </p>
                    <p className="text-sm" data-id="element-3171">
                      Permits will not be issued for the use of double bottoms
                      (truck tractor, semi-trailer and trailer or truck tractor
                      and 2 semi-trailers, or truck and trailer or semi-trailer){' '}
                      <strong data-id="element-3172">
                        except for the movement of loads that are overlength
                        only
                      </strong>
                      .
                    </p>
                  </div>
                </div>
              </div>

              {/* Section C */}
              <div className="bg-purple-50 rounded-lg p-6" data-id="element-3173">
                <div className="flex items-start mb-3" data-id="element-3174">
                  <span className="bg-purple-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3175">
                    C
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3176">
                    Superloads & Special Consideration
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3177">
                  <p data-id="element-3178">
                    As a matter of general procedure, permits will not be issued
                    for transportation of loads exceeding limitations specified
                    in "Single Trips" below. Efforts should be made to move
                    vehicles or loads exceeding these limitations by some means
                    other than by highway or to dismantle the object being
                    moved.
                  </p>

                  <div className="bg-white rounded-lg p-4" data-id="element-3179">
                    <p className="font-semibold mb-2" data-id="element-3180">
                      Special Loads Consideration:
                    </p>
                    <p className="text-sm mb-2" data-id="element-3181">
                      Issuance of permits may be considered for limited movement
                      of special loads if:
                    </p>
                    <ul className="space-y-1 text-sm" data-id="element-3182">
                      <li data-id="element-3183">
                        • All efforts to utilize other means of transportation
                        have been exhausted
                      </li>
                      <li data-id="element-3184">
                        • The object being moved cannot feasibly be reduced to
                        comply with specified limitations
                      </li>
                      <li data-id="element-3185">
                        • A complete written explanation is submitted with
                        properly completed application
                      </li>
                    </ul>
                  </div>

                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4" data-id="element-3186">
                    <p className="font-bold text-red-900 mb-2" data-id="element-3187">
                      ⚠️ IMPORTANT TIMING REQUIREMENT:
                    </p>
                    <p className="text-sm" data-id="element-3188">
                      It is not possible to give immediate attention to requests
                      for permits in excess of usual limitations (superloads,
                      house moves). Applications and written explanations for
                      special consideration must be on file in the Lansing
                      permit office at least{' '}
                      <strong data-id="element-3189">ten (10) working days prior</strong> to the
                      tentative date of movement.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section D */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-3190">
                <div className="flex items-start mb-3" data-id="element-3191">
                  <span className="bg-gray-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3192">
                    D
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3193">
                    Vehicle Gauge
                  </h3>
                </div>
                <p className="text-gray-700 ml-14" data-id="element-3194">
                  The measurement across the vehicle from outside of tire to
                  outside of tire on the self-propelled equipment or the trailer
                  or semi-trailer or other towed equipment.{' '}
                  <strong data-id="element-3195">
                    This information is required for overweight loads only.
                  </strong>
                </p>
              </div>

              {/* Section E */}
              <div className="bg-red-50 rounded-lg p-6" data-id="element-3196">
                <div className="flex items-start mb-3" data-id="element-3197">
                  <span className="bg-red-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3198">
                    E
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3199">
                    <Scale className="mr-2" size={20} data-id="element-3200" />
                    Weight Restrictions
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3201">
                  <p data-id="element-3202">
                    A request for an overweight permit will not be approved for
                    a load consisting of more than one object, and in no event,
                    shall any wheel load exceed{' '}
                    <strong data-id="element-3203">700 pounds per inch of tire width</strong>.
                  </p>

                  <div className="bg-white rounded-lg p-4" data-id="element-3204">
                    <p className="font-semibold mb-2" data-id="element-3205">Exception:</p>
                    <p className="text-sm" data-id="element-3206">
                      Permits will be approved for empty self-propelled earth
                      moving equipment provided it does not exceed{' '}
                      <strong data-id="element-3207">850 pounds per inch of tire width</strong>.
                    </p>
                  </div>

                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-3208">
                    <p className="font-bold text-yellow-900 mb-2" data-id="element-3209">
                      Spring Weight Restriction Period:
                    </p>
                    <p className="text-sm" data-id="element-3210">
                      <strong data-id="element-3211">No overweight permits will be issued</strong>{' '}
                      during the spring weight restriction period, except in
                      case of public emergency.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section F */}
              <div className="bg-green-50 rounded-lg p-6" data-id="element-3212">
                <div className="flex items-start mb-3" data-id="element-3213">
                  <span className="bg-green-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3214">
                    F
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3215">
                    <Ruler className="mr-2" size={20} data-id="element-3216" />
                    Width Restrictions
                  </h3>
                </div>
                <div className="ml-14" data-id="element-3217">
                  <div className="bg-yellow-50 border-l-4 border-yellow-500 p-4" data-id="element-3218">
                    <p className="text-gray-700" data-id="element-3219">
                      Permits will not be issued for widths in excess of{' '}
                      <strong data-id="element-3220">14 feet</strong> during the spring weight
                      restriction period, except in a case of public emergency.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section G */}
              <div className="bg-orange-50 rounded-lg p-6" data-id="element-3221">
                <div className="flex items-start mb-3" data-id="element-3222">
                  <span className="bg-orange-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3223">
                    G
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg" data-id="element-3224">
                    Height Restrictions
                  </h3>
                </div>
                <div className="ml-14 space-y-3 text-gray-700" data-id="element-3225">
                  <p data-id="element-3226">
                    Careful consideration must be given to any application
                    requesting movement where the overall height exceeds{' '}
                    <strong data-id="element-3227">13 feet 6 inches</strong> because of possible
                    overhead obstructions on proposed routes.
                  </p>

                  <div className="bg-red-50 border-2 border-red-500 rounded-lg p-4" data-id="element-3228">
                    <p className="font-bold text-red-900 mb-2" data-id="element-3229">
                      CERTIFICATION REQUIRED:
                    </p>
                    <p className="text-sm" data-id="element-3230">
                      All applications for permits in excess of 13 feet 6 inches
                      shall certify that the proposed route has been traveled to
                      assure vertical clearance.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section H */}
              <div className="bg-indigo-50 rounded-lg p-6" data-id="element-3231">
                <div className="flex items-start mb-3" data-id="element-3232">
                  <span className="bg-indigo-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3233">
                    H
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3234">
                    <Car className="mr-2" size={20} data-id="element-3235" />
                    Escort Vehicles
                  </h3>
                </div>
                <div className="ml-14 space-y-3" data-id="element-3236">
                  <div className="bg-white rounded-lg p-4" data-id="element-3237">
                    <p className="font-semibold text-gray-900 mb-3" data-id="element-3238">
                      Requirements:
                    </p>
                    <ul className="space-y-2 text-gray-700 text-sm" data-id="element-3239">
                      <li className="flex items-start" data-id="element-3240">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3241" />
                        <span data-id="element-3242">Must be a passenger car or pickup truck</span>
                      </li>
                      <li className="flex items-start" data-id="element-3243">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3244" />
                        <span data-id="element-3245">
                          At least one flashing or rotating light on top of the
                          cab
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-3246">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3247" />
                        <span data-id="element-3248">
                          <strong data-id="element-3249">Oversize Load sign</strong> displayed on roof:
                          5 feet long × 12 inches high with 8-inch high black
                          letters on yellow background
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-3250">
                        <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-0.5" size={16} data-id="element-3251" />
                        <span data-id="element-3252">
                          All flashing or rotating amber lights shall be visible
                          for a distance of <strong data-id="element-3253">500 feet</strong>
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              {/* Section I */}
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-3254">
                <div className="flex items-start mb-3" data-id="element-3255">
                  <span className="bg-blue-600 text-white font-bold px-3 py-1 rounded mr-4 flex-shrink-0" data-id="element-3256">
                    I
                  </span>
                  <h3 className="font-bold text-gray-900 text-lg flex items-center" data-id="element-3257">
                    <Clock className="mr-2" size={20} data-id="element-3258" />
                    Time Restrictions
                  </h3>
                </div>
                <div className="ml-14 space-y-3" data-id="element-3259">
                  <p className="text-gray-700" data-id="element-3260">
                    Permits are issued for{' '}
                    <strong data-id="element-3261">daylight hours only, Monday through Friday</strong>.
                    In some instances, other time limitations may be applied.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Holiday Restrictions */}
          <div className="bg-red-50 border-2 border-red-500 rounded-lg shadow-md p-8 mb-8" data-id="element-3262">
            <h2 className="text-2xl font-bold text-red-900 mb-6 flex items-center" data-id="element-3263">
              <AlertTriangle className="mr-3" size={28} data-id="element-3264" />
              Holiday Movement Restrictions
            </h2>

            <div className="bg-white rounded-lg p-6 mb-4" data-id="element-3265">
              <p className="text-gray-800 font-semibold mb-4" data-id="element-3266">
                Under no condition will a permit be issued for a movement to
                take place from{' '}
                <strong data-id="element-3267">12:00 noon on the day preceding the holiday</strong> and
                continuing until{' '}
                <strong data-id="element-3268">daylight of the first day after</strong> the holidays
                listed below:
              </p>

              <div className="grid md:grid-cols-2 gap-3" data-id="element-3269">
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3270">
                  <span className="text-2xl mr-3" data-id="element-3271">🎄</span>
                  <span className="font-semibold" data-id="element-3272">Christmas Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3273">
                  <span className="text-2xl mr-3" data-id="element-3274">🦃</span>
                  <span className="font-semibold" data-id="element-3275">Thanksgiving Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3276">
                  <span className="text-2xl mr-3" data-id="element-3277">🇺🇸</span>
                  <span className="font-semibold" data-id="element-3278">Memorial Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3279">
                  <span className="text-2xl mr-3" data-id="element-3280">👷</span>
                  <span className="font-semibold" data-id="element-3281">Labor Day</span>
                </div>
                <div className="bg-red-50 rounded-lg p-3 flex items-center" data-id="element-3282">
                  <span className="text-2xl mr-3" data-id="element-3283">🎆</span>
                  <span className="font-semibold" data-id="element-3284">Independence Day</span>
                </div>
              </div>
            </div>
          </div>

          {/* Key Takeaways */}
          <div className="bg-gradient-to-r from-green-600 to-green-700 text-white rounded-lg shadow-xl p-8 mb-8" data-id="element-3285">
            <h2 className="text-3xl font-bold mb-6" data-id="element-3286">Key Takeaways</h2>

            <div className="space-y-3" data-id="element-3287">
              <div className="flex items-start" data-id="element-3288">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3289" />
                <span data-id="element-3290">
                  Permits only for loads that cannot be divided, dismantled, or
                  reduced
                </span>
              </div>
              <div className="flex items-start" data-id="element-3291">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3292" />
                <span data-id="element-3293">
                  Issued to business entities/individuals actually doing the
                  transporting
                </span>
              </div>
              <div className="flex items-start" data-id="element-3294">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3295" />
                <span data-id="element-3296">
                  Staggered loading not permitted; loads arranged for minimum
                  dimensions
                </span>
              </div>
              <div className="flex items-start" data-id="element-3297">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3298" />
                <span data-id="element-3299">
                  Superloads require 10 working days advance notice to Lansing
                  office
                </span>
              </div>
              <div className="flex items-start" data-id="element-3300">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3301" />
                <span data-id="element-3302">
                  Max wheel load: 700 lbs/inch (850 lbs/inch for empty earth
                  moving equipment)
                </span>
              </div>
              <div className="flex items-start" data-id="element-3303">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3304" />
                <span data-id="element-3305">
                  No overweight permits during spring weight restrictions
                  (except emergencies)
                </span>
              </div>
              <div className="flex items-start" data-id="element-3306">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3307" />
                <span data-id="element-3308">Width limit 14 feet during spring restrictions</span>
              </div>
              <div className="flex items-start" data-id="element-3309">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3310" />
                <span data-id="element-3311">
                  Height &gt;13'6": Route must be pre-traveled to verify
                  clearance
                </span>
              </div>
              <div className="flex items-start" data-id="element-3312">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3313" />
                <span data-id="element-3314">
                  Escort vehicles: Oversize Load sign (5'×12") + amber lights
                  visible 500 feet
                </span>
              </div>
              <div className="flex items-start" data-id="element-3315">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3316" />
                <span data-id="element-3317">
                  Daylight hours only, Monday-Friday (other restrictions may
                  apply)
                </span>
              </div>
              <div className="flex items-start" data-id="element-3318">
                <CheckCircle className="mr-3 flex-shrink-0 mt-1" size={20} data-id="element-3319" />
                <span data-id="element-3320">
                  No movement from noon before holiday until daylight after (5
                  major holidays)
                </span>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-3321">
            <h2 className="text-3xl font-bold mb-4" data-id="element-3322">
              Need Help with Oversize/Overweight Permits?
            </h2>
            <p className="text-xl mb-6" data-id="element-3323">
              Expert guidance on special transport permits and compliance
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-3324">
              <Phone className="mr-3" size={24} data-id="element-3325" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-3326">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}